<template>
    <div class="container-fluid  pt-2">
        <div class="container">
            <div class="row">
                <div class="col-md-6 col-sm-12">
                    <div class="text-left">
                        <h4 class="text-weight-700 text-dark">    Expenses</h4>
                    </div>
                </div>
                <div class="col-md-6 col-sm-12">
                    <div class="btn-group float-right">
                        
                        <a  v-on:click="CreateModal" class="btn btn-primary btn-sm mx-1 rounded">Create an Expense</a>
                    </div>
                </div>

            </div>
            <div>
                
                    <div class="row py-3">
                        <div class="col-md-6 col-sm-12">
                            <form>
                                <div class="col-auto">
                                    <div class="input-group mb-2">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text"><i class="fas fa-search"></i></div>
                                        </div>
                                        <input type="text" class="form-control border border-gray" v-model="searchExpense" id="inlineFormInputGroup" placeholder="Search Expenses">
                                    </div>
                                </div>
                            </form>
                      
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <date-range-picker :auto-apply="autoApply" v-model="dateRange" class="custom-width-datepicker">
                                <template #input="picker" style="width: 100% !important;">
                                    <p v-if="picker.startDate !==null && picker.endDate !==null">{{ FormatDate(picker.startDate) }} - {{ FormatDate(picker.endDate) }}</p>
                                    <p v-else><i class="bi bi-calendar-event"></i>  Filter by Date</p>
</template>
                        </date-range-picker>

                    </div>
                </div>

          
        
            <div v-if="expenses.length === 0">
            <div class=" h-100 d-flex justify-content-center align-items-center">
                <div class="text-center mt-5 pt-5">
                    <h1><i class="bi bi-emoji-smile"></i></h1>
                    <h4 class="text-center py-3">No expenses recorded</h4>
                    <div class="btn-group">
                        <a  href="/expenses" class="btn btn-secondary btn-sm rounded mx-1" >Reload <i class="bi bi-arrow-repeat"></i></a>
                       
                        <a  v-on:click="CreateModal" class="btn btn-primary btn-sm rounded mx-1">Create an Expense</a>

                    </div>

                </div>
            </div>



        </div>
            <div v-else class="row">
                <div class="col-md-6 col-sm-12 col-md-6">
               
                              
                                    <p>   <i class="fas fa-coins"></i>
                            {{convertCurrencyToLocal(totalexpenses)}}</p>
                                    <p><small>All Expenses</small></p>
                            
                </div>
                <div class="col-md-6 col-sm-6 col-md-6">
                   
                          
                                    <p > <i class="bi bi-graph-up" style="font-size: 1em"></i> {{convertCurrencyToLocal(highestexpenses)}}</p>
                           

                                    <p><small>Highest Expense</small></p>
                               
                            
                   
                </div>




            </div>
            <hr/>


            <b-table v-if="items.length > 0"
                    sticky-header="100vh"
                    hover
                    :items="items"
                    :fields="fields"
                    sort-icon-left
                    responsive="sm"
                    @row-clicked="RowSelected"
            >
            <template #cell(index)="data">
                {{ data.index + 1 }}
            </template>

            <template #cell(expense)="data">
                <p class="text-primary"> {{ data.item.expense }}</p>
            </template>

            </b-table>
        </div>



        <!--Page modals-->
        <b-modal ref="createexpensemodal" id="modal-center"  hide-footer static>
            <div class="text-center">

                <h2 class="text-weight-700 text-primary">Create Expense</h2>
                <hr/>
                <b-form @submit="CreateExpense">

                        <b-form-input
                                id="input-1"
                                v-model=expenseForm.expense
                                type="text"
                                class="border my-2"
                                placeholder="Enter Expense Title"
                               
                        ></b-form-input>


                    <b-form-select  class="border my-2" v-model="expenseForm.selectedExpenseCategory" :options="expenseForm.expenseCatOptions"></b-form-select>
                    <p class="text-left">Can't see a category? <a @click="createExpenseCategoryModalShow" href="#">Create Expense Category</a></p>
                    <date-range-picker
                    id="input-1"
                            v-model=expenseForm.expenseDate
                            type="text"
                            class="w-100"
                            single-date-picker
                            :ranges=false
                            auto-apply
                         
                            >
                            <template #input="picker" style="width: 100% !important;">
                                <p v-if="picker.startDate">{{ FormatDate(picker.startDate)}}</p>
                                    <p v-else><i class="bi bi-calendar-event"></i>  Select to change expense date</p>
                                    
                                </template>
                    </date-range-picker>
                    

                    <hr/>
                    <b-textarea 
                            v-model=expenseForm.notes
                            type="text"
                            class="border my-2"
                            placeholder="Notes/Reason"
                           
                    >

                    </b-textarea>
                    <b-form-input
                            id="input-1"
                            v-model=expenseForm.expenseamount
                            type="text"
                            class="border my-2"
                            placeholder="Amount Spent"
                        
                    ></b-form-input>
                    
                    <b-button type="submit" variant="primary" class="btn-block">Submit</b-button>

                    </b-form>
            </div>
        </b-modal>

            <b-modal ref="createExpenseCategoryModal" id="modal-1" hide-footer static>
                <p class="my-4 text-center text-primary ">Create Expense Category</p>
                <b-form @submit.prevent="createExpenseCategory">

                    <b-form-input
                            id="input-1"
                            v-model=expensecategoryname
                            type="text"
                            class="border my-2"
                            placeholder="Enter Expense Category"
                            required
                    ></b-form-input>



                    <b-button type="submit" variant="primary" class="btn-block">Submit</b-button>

                </b-form>

            </b-modal>
        <b-modal ref="editexpensemodal" id="modal-center"  hide-footer static>
            <div class="text-center">

                <h2 class="text-weight-700 text-primary text-capitalize">Edit {{selectedexpense.expense}}</h2>
                
                <hr/>
                <b-form @submit.prevent="editExpenseSub">

                        <b-form-input
                                id="input-1"
                                v-model=expenseForm.expense
                                type="text"
                                class="border my-2"
                                placeholder="Enter Expense Title"
                        ></b-form-input>


                    <b-form-select  class="border my-2" v-model="expenseForm.selectedExpenseCategory" :options="expenseForm.expenseCatOptions"></b-form-select>
                    <b-form-input
                            id="input-1"
                            v-model=expenseForm.expenseAmount
                            type="text"
                            class="border my-2"
                            placeholder="Amount Spent"
                         
                    ></b-form-input>
                    <date-range-picker
                    id="input-1"
                            v-model=expenseForm.expenseDate
                            type="text"
                            class="w-100"
                            single-date-picker
                            :ranges=false
                            auto-apply
                         
                            >
                            <template #input="picker" style="width: 100% !important;">
                                <p v-if="picker.startDate">{{ FormatDate(picker.startDate)}}</p>
                                    <p v-else><i class="bi bi-calendar-event"></i>  Select to change expense date</p>
                                    
                                </template>
                    </date-range-picker>
                    <b-button type="submit" variant="primary" class="btn-block">Submit</b-button>

                    </b-form>
            </div>
        </b-modal>

        <b-modal ref="expenseShowDetailsModal"  id="bv-modal-approve" hide-footer static>

            <div class="d-block text-left">
               
                <h5 class="text-weight-800 py-1">Expense Details</h5>

                <div class="pb-2">
                   
                        <h5 class="text-weight-400 py-1">Expense: <span>{{selectedexpense.expense}}</span></h5>
                        <h5 class="text-weight-400 py-1">Amount: <span> {{convertCurrencyToLocal(selectedexpense.amount)}}</span></h5>
                        <h5 class="text-weight-400 py-1" v-if="selectedexpense.reason">Reason/notes:{{ selectedexpense.reason }}</h5>
                        <h5 class="text-weight-400 py-1">Created by: <span class="text-capitalize">{{selectedexpense.created_by}}</span></h5>
                        <h5 class="text-weight-400 py-1">Status: <span>{{selectedexpense.status}}</span></h5>
                        <h5 class="text-weight-400 py-1">Created on: <span>{{selectedexpense.created_on}}</span></h5>
                
                </div>
<hr/>
<p class="text-danger">
    To change the expense date just click edit and change the date
</p>
<hr/>
                <div v-if="selectedexpense.status === 'Pending'">

                    <div class="btn-group">
                        <button class="btn btn-outline-danger rounded btn-sm mx-1" v-if="selectedexpense.status ==='Pending'" v-on:click="actionExpense('delete',selectedexpense.expense_id)">Delete </button>
                        <button  v-if="userDetails.roles[0].name === 'Admin' || hasPermission('can manage expenses')" class="btn btn-outline-dark btn-sm rounded mx-1" v-on:click="actionExpense('reject',selectedexpense.expense_id)">Reject </button>
                     

                      
                        <button class="btn btn-outline-dark rounded btn-sm mx-1" v-if="selectedexpense.status ==='Pending'" v-on:click="editExpense(selectedexpense.expense_id)">Edit </button>
                        <button  v-if="userDetails.roles[0].name === 'Admin' || hasPermission('can manage expenses')" class="btn btn-primary btn-sm rounded mx-1" v-on:click="approveExpenseModal()">Approve </button>


                    </div>
                </div>
                <div v-else>
                    <div class="btn-group">
                        <button class="btn btn-outline-danger rounded btn-sm mx-1"
                            v-on:click="actionExpense('delete',selectedexpense.expense_id)">Delete </button>
                        <button class="btn btn-outline-dark rounded btn-sm mx-1"
                            v-on:click="editExpense(selectedexpense.expense_id)">Edit </button>

                    </div>
                </div>



            </div>

        </b-modal>
        <b-modal ref="expenseModalApprove" hide-footer static>

            <div class="d-block text-left">
                <p class="text-weight-700 text-success"><i class="fas fa-check-circle-o fa-2x"></i></p>
                <h5 class="text-weight-800 py-1 text-center">Select source of funds</h5>
                <h5 class="text-weight-800 py-1 text-center">Expense: <small>{{selectedexpense.expense}}</small></h5>
                <h5 class="text-weight-800 py-1 text-center">Amount: <small>{{convertCurrencyToLocal(selectedexpense.amount)}}</small></h5>

            
                       <small class="text-danger" v-if="noPaymentSelected !==''">{{ noPaymentSelected }}</small>
                        <select v-model="sourceOfExpenseFunds" class="form-control">
                            <option value="null">Select source of funds</option>
                            <option v-for="payment in approveExpensePayments" :value="payment.id">{{ payment.payment_method }}</option>
                            
                        </select>
                 
                    
                   


                <div v-if="selectedexpense.status === 'Pending'" class="my-2">



                        <button  v-if="userDetails.roles[0].name === 'Admin' || hasPermission('can manage expenses')" class="btn btn-outline-primary btn-block btn-sm rounded mx-1" v-on:click="approveExpense(selectedexpense.expense_id)">Approve </button>
                      
               
                </div>
                



            </div>

        </b-modal>
    </div>
    </div>
</template>

<script>
    import DateRangePicker from "vue2-daterange-picker/src/components/DateRangePicker";
    import {mapGetters} from 'vuex'
    export default {
        name: 'expenses',
        components: {
            DateRangePicker
        },
        data() {
            return {
               
                expenses: '',
                highestexpenses: '',
                totalexpenses: '',
                expensecategoryname: '',
                expenseId: '',
                expensestatus: '',
                expenseForm: {
                    expense: '',
                    selectedExpenseCategory: null,
                    expenseAmount: '',
                    expenseAmount: '',
                    notes: '',
                    expenseCreatedDate: '',
                    expenseCatOptions: [],
                    expenseDate: {
                        startDate: null,
                        endDate: null,
                    },
                },
                approveExpensePayments:[],
                sourceOfExpenseFunds:null,
                searchExpense: '',
                fields: [
                    'index',
                    {
                        key: 'expense',
                        sortable: true
                    },
                    {
                        key: 'amount',
                        sortable: true
                    },
                    {
                        key: 'status',
                        sortable: true
                    },
                    {
                        key: 'created_by',
                        sortable: true
                    },
                    {
                        key: 'created_on',
                        sortable: true
                    }
                ],
                items: [],
                selectedexpense: {},
                dateRange: {
                    startDate: null,
                    endDate: null,
                },
                autoApply: true,
                noPaymentSelected:''
            }
        },
        computed:{
            ...mapGetters(['userDetails']),
        },
        mounted() {
            this.checkIfExpenseIdHasBeenSet();
        },
        watch: {
            searchExpense(before, after) {
                this.getExpenses()
            },
            dateRange: {
                deep: true,
                handler(after, before) {
                    if (after.startDate && after.endDate) {
                        const urlParams = new URLSearchParams(window.location.search);
                        const startDateString = after.startDate.toISOString().split('T')[0]; // Convert to ISO format without time
                        const endDateString = after.endDate.toISOString().split('T')[0]; // Convert to ISO format without time

                        urlParams.set('start-date', startDateString);
                        urlParams.set('end-date', endDateString);

                        window.history.replaceState(null, null, '?' + urlParams.toString());
                     }
                this.getExpenses()
            }
        }
        },
        methods: {
            RowSelected(items) {
                this.selectedexpense = items;
                this.$refs['expenseShowDetailsModal'].show();
            },
            checkIfExpenseIdHasBeenSet()
            {
                const urlParams = new URLSearchParams(window.location.search);

                // Check if the 'bulk-action' parameter exists
                if (urlParams.has('expense-id')) {
                    this.expenseId = urlParams.get('expense-id')
                }
            
              this.getExpenses();
              
            },
            hasPermission(permissionName) {
                 return this.userDetails.permissions.some(permission => permission.name === permissionName);
            },
            editExpenseSub() {
               
                axios.put('/api/expense', {
                       
                        expense_id: this.selectedexpense.expense_id,
                       ...this.expenseForm,
                       
                    })
                    .then(result => {
                        if (result.data.status == 200) {
                            this.getExpenses();
                            this.$refs['editexpensemodal'].hide();
                            this.$toasts.push({
                                type: 'success',
                                message: result.data.message,
                            });
                        } else {
                            this.getExpenses();
                            this.$refs['createexpensemodal'].show();
                            this.$toasts.push({
                                type: 'error',
                                message: result.data.message,
                            });
                         
                        }
                    }).catch(errors => {
                  
                    });
            },
           async getExpenses() {
            const urlParams = new URLSearchParams(window.location.search);
               await axios.get('/api/expenses', {
                        params: {
                            search: this.searchExpense,
                            startdate: urlParams.get('start-date'),
                            enddate: urlParams.get('end-date'),
                   
                            expenseId: this.expenseId
                        
                        }
                    })
                    .then(result => {
                       
                            this.expenses = result.data.expenses;
                            this.userDetails.roles[0].name = result.data.userdetails;
                            let itemarray = [];
                            if(this.expenseId === ''){
                                $.each(result.data.expenses, function(key, value) {
                                let status = '';
                                let personaldetails = '';
                                if (value.created_by !== null) {
                                    personaldetails = value.created_by.name
                                } else if (value.created_by === null) {
                                    personaldetails = '';
                                }
                                if (value.status === 1) {
                                    status = "Approved"
                                } else if (value.status === 0) {
                                    status = "Pending";
                                } else if (value.status === 2) {
                                    status = "Rejected";
                                }
                                // Date
                                let createddate = moment(value.created_at).format('HH:mm DD-MM-YYYY');
                                itemarray.push({
                                    'expense_id': value.id,
                                    'expense': value.expense,
                                    'reason': value.reason,
                                    'amount': value.amount,
                                    'status': status,
                                    'created_by': personaldetails,
                                    'created_on': createddate
                                })
                            });
                            this.items = itemarray;
                            
                            }
                            else{
                                const expenseDetails = result.data.expenses
                                let status=''
                                if (expenseDetails.status === 1) {
                                    status = "Approved"
                                } else if (expenseDetails.status === 0) {
                                    status = "Pending";
                                } else if (expenseDetails.status === 2) {
                                    status = "Rejected";
                                }
                                this.items.push({
                                    'expense_id': expenseDetails.id,
                                    'expense': expenseDetails.expense,
                                    'reason': expenseDetails.reason,
                                    'amount': expenseDetails.amount,
                                    'status': status,
                                    'created_by': expenseDetails.created_by.name,
                                    'created_on': moment(expenseDetails.created_at).format('HH:mm DD-MM-YYYY')
                                })
                               
                               
                                this.selectedexpense = this.items[0]
                                this.$refs['expenseShowDetailsModal'].show();
                
                            }
                            this.totalexpenses = result.data.totalexpenses;
                            this.highestexpenses = result.data.highestexpenses;
                            
                            let listoption = [{
                                value: null,
                                text: 'Select Category'
                            }, ];
                            $.each(result.data.expensecategories, function(key, value) {
                                listoption.push({
                                    'value': value.id,
                                    'text': value.name
                                });
                            });
                           
                            this.expenseForm.expenseCatOptions = listoption
                        
                      
                    }).catch(error => {
                      
                    });
            },
            // open create expense modal
            CreateModal() {
                
                this.$refs['createexpensemodal'].show();
            },

            approveExpenseModal(expense_id) {
                this.getPaymentDetails();
                this.$refs.expenseShowDetailsModal.hide()
                this.$refs.expenseModalApprove.show();
            },
            editExpense(expense_id) {
                this.$refs['expenseShowDetailsModal'].hide();
                this.$refs['editexpensemodal'].show();
                // window.location.reload
            },
            Deleteexpense(expense_id) {
                this.$refs['expensemodaldel'].show();
            },
            actionExpense(action, id) {
                
                axios.post('/api/expenseaction/' + action, {
                    expense_id: id
                }).then(results => {
                    this.$refs['expenseShowDetailsModal'].hide();
                    window.location.reload
                    this.$toasts.push({
                        type: results.data.type,
                        message: results.data.message,
                    });
                }).catch(error => {
                   
                });
            },
            approveExpense(id)
            {
                if(this.sourceOfExpenseFunds !==null)
                {
                    axios.post('/api/expense-approve', {
                    expenseId: id,
                    expenseSource: this.sourceOfExpenseFunds
                }).then(results => {
                    if(results.status === 200)
                    {
                        this.$refs.expenseModalApprove.hide();
                        window.location.reload
                    this.$toasts.push({
                        type: 'success',
                        message: 'Expense approved',
                    });
                    }
                 
                }).catch(error => {
                    
                });
                }
                else{
                    this.noPaymentSelected = "You need to select source of funds"
                }
               
            },
            CreateExpense(event) {
                event.preventDefault();
                axios.post('/api/expense/create', {
                        expensetitle: this.expenseForm.expense,
                        category_id: this.expenseForm.selectedExpenseCategory,
                        expenseamount: this.expenseForm.expenseamount,
                        notes: this.expenseForm.notes,
                        expenseDate: this.expenseForm.expenseDate
                    })
                    .then(result => {
                        if (result.data.status == 200) {
                            window.location.reload
                            this.$refs['createexpensemodal'].hide();
                            this.expenseForm.selectedExpenseCategory = '';
                            this.expenseForm.expenseamount = '';
                            this.expenseForm.expense = '';
                            this.$toasts.push({
                                type: 'success',
                                message: result.data.message,
                            });
                        } 
                    }).catch(e=>{
                      
                            this.$toasts.push({
                                type: 'error',
                                message: e.response.data.message,
                            });
                    });
            },
            FormatDate(date) {
                let finaldate = moment(date).format('DD-MMM-YYYY');
                return finaldate;
            },
            formatDates(dateOne, dateTwo) {
                let formattedDates = ''
                if (dateOne) {
                    formattedDates = format(dateOne, this.dateFormat)
                }
                if (dateTwo) {
                    formattedDates += ' - ' + format(dateTwo, this.dateFormat)
                }
                // this.leaveform.daterange = formattedDates;
                return formattedDates
            },
            GetfilteredExpenses() {
            },
            createExpenseCategoryModalShow()
            {
                this.$refs.createExpenseCategoryModal.show()

            },
            getPaymentDetails() {
                axios.get('/api/payments',{params:{enabled:true}})
                    .then(results => {
                        const paymentModes = results.data
                        paymentModes.forEach(element => {
                     
                            if(element.payment_method.toLowerCase() === 'cash' || element.payment_method.toLowerCase() === 'm-pesa' )
                            {
                                this.approveExpensePayments.push(element)
                            }
                        });
                        
                       
                    }).catch(errors => {
                       
                    });
            },
            createExpenseCategory() {
                
                axios.post('/api/expense-category', {
                    category: this.expensecategoryname
                }).then(results => {
                    
                    this.expenseForm.selectedExpenseCategory = results.data.category.id
                   
                    this.$refs.createExpenseCategoryModal.hide()
              
                }).catch(error => {
                   
                });
            }
        }
    }
</script>

<style>
    .custom-width-datepicker {
        width: 100% !important
    }
</style>